import { render, staticRenderFns } from "./ImportPortfolioDuplicates.vue?vue&type=template&id=bf663e7e&"
import script from "./ImportPortfolioDuplicates.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioDuplicates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports